import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/forbid-foreign-prop-types */
/**
 * A field adapter for axe-prop-types package
 */

import { FieldType } from '@beefco/types';
import { filter } from '@beef/utils';
var convertAxeToFieldType = function convertAxeToFieldType(_ref) {
  var propTypeName = _ref.propTypeName,
    allowedPropTypes = _ref.allowedPropTypes;
  switch (propTypeName) {
    case 'string':
      return FieldType.STRING;
    case 'number':
      return FieldType.NUMBER;
    case 'bool':
      return FieldType.BOOLEAN;
    case 'node':
      return FieldType.NODE;
    case 'oneOf':
      return FieldType.CHOICE;
    case 'arrayOf':
      return FieldType.ANY;
    case 'func':
      return FieldType.ANY;
      throw new Error('Func types not supported yet');
    case 'oneOfType':
      /** string or node, for rich text fields */
      if (allowedPropTypes.find(function (_ref2) {
        var info = _ref2.info;
        return info.propTypeName === 'string';
      }) && allowedPropTypes.find(function (_ref3) {
        var info = _ref3.info;
        return info.propTypeName === 'node';
      })) {
        return FieldType.TEXT;
      }
    default:
      return FieldType.ANY;
      throw new Error("Unknown type ".concat(propTypeName));
  }
};

/**
 * Special condition hack for mul-like definition:
 * PropTypes.oneOfType([
 *   PropTypes.oneOf([...]),
 *   PropTypes.string,
 * ])
 */
var extractNestedOneOf = function extractNestedOneOf(allowedPropTypes, key) {
  var oneOfPropType = allowedPropTypes.find(function (_ref4) {
    var info = _ref4.info;
    return info.propTypeName === 'oneOf';
  });
  return oneOfPropType ? convertAxePropToField(oneOfPropType, key) : undefined;
};
var convertAxePropToField = function convertAxePropToField(axeProp, key) {
  // TODO: try/catch might be better?
  if (typeof axeProp.info === 'undefined') {
    throw new Error('Missing propTypes metadata, maybe axe-prop-types is not properly injected');
  }
  var _axeProp$info = axeProp.info,
    isRequired = _axeProp$info.isRequired,
    allowedValues = _axeProp$info.allowedValues,
    allowedPropTypes = _axeProp$info.allowedPropTypes,
    propTypeName = _axeProp$info.propTypeName;
  return _objectSpread(_objectSpread({
    choices: allowedValues,
    type: convertAxeToFieldType(axeProp.info)
  }, propTypeName === 'oneOfType' && extractNestedOneOf(allowedPropTypes, key) || {}), {}, {
    alias: key,
    name: key,
    required: isRequired,
    default: axeProp.default
  });
};
var extractComponentStatics = function extractComponentStatics(Component) {
  var defaultStatics = {
    propTypes: {},
    defaultProps: {}
  };
  /**
   * TODO: Handle endless recursion case. It is invalid, but possible
   *
   * React-redux connect doesn't hoist statics by default, instead it saved WrappedComponent reference
   */
  while (!Component.propTypes) {
    if (!Component.WrappedComponent) return defaultStatics;
    Component = Component.WrappedComponent;
  }
  var _Component = Component,
    propTypes = _Component.propTypes,
    defaultProps = _Component.defaultProps;
  return _objectSpread(_objectSpread({}, defaultStatics), filter({
    propTypes: propTypes,
    defaultProps: defaultProps
  }, function (value) {
    return !!value;
  }));
};
export var extractComponentDSL = function extractComponentDSL(component) {
  var _extractComponentStat = extractComponentStatics(component),
    propTypes = _extractComponentStat.propTypes,
    defaultProps = _extractComponentStat.defaultProps;
  return Object.keys(propTypes).map(function (key) {
    return convertAxePropToField(_objectSpread(_objectSpread({}, propTypes[key]), {}, {
      default: defaultProps[key]
    }), key);
  });
};